import { Footer } from "antd/lib/layout/layout";
import React from "react";
import styles from "./CsaFooter.module.scss";
import fb from "../../images/facebook.png";
import insta from "../../images/instagram.png";
import Logo from "../../images/logo.png";
import mfb from "../../images/mobFB.png";
import minsta from "../../images/mobInsta.png";
import mtwitter from "../../images/mobTweet.png";
import twitter from "../../images/twitter.png";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";

function CSAFooter() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear().toString();
  const app_version = process.env.REACT_APP_VERSION_NUMBER;

  return (
    <Footer className={styles.CsaFooterWrapper}>
      <Row className="w-100 d-none d-lg-flex d-xl-flex " align="bottom">
        &nbsp;
        <Col span={6} className={styles.yellow}>
          <img src={Logo} alt="logo-footer" onClick={() => navigate("/home")} />
        </Col>
        <Col span={18} className={styles.green}>
          <Row align="middle">
            <Col span={12}>
              <p className={styles.copyRight}>
                Copyright © {currentYear}. All rights reserved. Version {app_version}
              </p>
            </Col>
            <Col span={12}>
              <Row align="middle" justify="end" className="px-5">
                <Col className="px-3">
                  <p className={styles.copyRight}>Get in touch!</p>
                </Col>
                <Col className="mx-1 mt-3">
                  <img src={fb} alt="fb" />{" "}
                </Col>
                <Col className="mx-1 mt-3">
                  <img src={insta} alt="insta" />
                </Col>
                <Col className="mx-1 mt-3">
                  <img src={twitter} alt="tweet" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        xs={24}
        sm={24}
        md={24}
        lg={0}
        xl={0}
        className="w-100 d-flex d-lg-none d-xl-none"
        align="middle"
        justify=""
      >
        <div className={styles.mobFooter}>
          <img src={Logo} alt="logo-footer" onClick={() => navigate("/home")} />
          <p className={styles.copyRight}>
            Copyright © {currentYear}. All rights reserved. Version {app_version}
          </p>

          <p className={styles.copyRight}>Get in touch!</p>
          <Row align="middle" justify="center" className="px-2 mt-1">
            <Col className="mx-1">
              <img src={mfb} alt="fb" />{" "}
            </Col>
            <Col className="mx-1">
              <img src={minsta} alt="insta" />
            </Col>
            <Col className="mx-1">
              <img src={mtwitter} alt="tweet" />
            </Col>
          </Row>
        </div>
      </Row>
    </Footer>
  );
}

export default CSAFooter;
